module.exports = __webpack_public_path__ + "static/img/about_item02.00dfeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_item02.png
// module id = j7PF
// module chunks = 2